export const D38 = {
    "columns": 6,
    "rows": 2,
    "visual": {
        "id": 13,
        "type": "advancedTable",
        "colorTheme": "colorTheme1",
        "title": "District Product Group",
        "binding": {
            "data": {
                "columns": [
                    {
                        "name": 'District Manager Code',
                        "columnName": 'DistrictManagerCode',
                        "width": '200px',
                        "align": "left",
                        "sortable": true,
                    },
                    {
                        "name": 'District Manager Name',
                        "columnName": 'DistrictManagerName',
                        "width": '200px',
                        "align": "left",
                        "sortable": true,
                    },
                    {
                        "name": 'Actual Sales',
                        "columnName": 'ActualSales',
                        "width": '125px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                    {
                        "name": 'LY Sales',
                        "columnName": 'LYSales',
                        "width": '125px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                    {
                        "name": 'Growth %',
                        "columnName": 'Growth',
                        "width": '125px',
                        "align": "right",
                        "sortable": true,
                        "sum": false,
                        "percent": true
                    },
                    {
                        "name": 'Target',
                        "columnName": 'TargetSales',
                        "width": '125px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                    {
                        "name": 'Performance %',
                        "columnName": 'Performance',
                        "width": '150px',
                        "align": "right",
                        "sortable": true,
                        "sum": false,
                        "percent": true
                    }
                ],
                "title": "DistrictManagerName",
                "endpoint": "D38",
                "parameters": [
                    { "key": "FromMonth", "value": "2024" },
                    { "key": "FromYear", "value": "1" },
                    { "key": "ToMonth", "value": "2024" },
                    { "key": "ToYear", "value": "1" },
                    { "key": "DistrictManagerCode", "value": "" },
                    { "key": "ConfigTypeCode", "value": "" }
                ]
            },
            "context": {
                "point": {
                    "onClick": {
                        "selectedValueColumn": "DistrictManagerCodeDistrictManagerName",
                        "selectedTitle": "PMR",
                        "visual": [
                            {
                                "columns": 12,
                                "rows": 2,
                                "visual": {
                                    "id": 1,
                                    "type": "advancedTable",
                                    "colorTheme": 'colorTheme1',
                                    "title": "PMR",
                                    "binding": {
                                        "data": {
                                            "columns": [
                                                {
                                                    "name": 'PMR Code',
                                                    "columnName": 'AgentCode',
                                                    "width": '200px',
                                                    "align": "left",
                                                    "sortable": true
                                                },
                                                {
                                                    "name": 'Employee Code',
                                                    "columnName": 'EmployeeCode',
                                                    "width": '200px',
                                                    "align": "left",
                                                    "sortable": true
                                                },
                                                {
                                                    "name": 'PMR Name',
                                                    "columnName": 'AgentName',
                                                    "width": '200px',
                                                    "align": "left",
                                                    "sortable": true
                                                },
                                                {
                                                    "name": 'Area Name',
                                                    "columnName": 'TerritoryName',
                                                    "width": '200px',
                                                    "align": "left",
                                                    "sortable": true
                                                },
                                                {
                                                    "name": 'Actual Sales',
                                                    "columnName": 'ActualSales',
                                                    "width": '140px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": true,
                                                },
                                                {
                                                    "name": 'LY Sales',
                                                    "columnName": 'LYSales',
                                                    "width": '125px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": true,
                                                },
                                                {
                                                    "name": 'Growth %',
                                                    "columnName": 'Growth',
                                                    "width": '125px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": false,
                                                    "percent": true
                                                },
                                                {
                                                    "name": 'Target',
                                                    "columnName": 'TargetSales',
                                                    "width": '125px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": true,
                                                },
                                                {
                                                    "name": 'Performance %',
                                                    "columnName": 'Performance',
                                                    "width": '150px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": false,
                                                    "percent": true
                                                }
                                            ],
                                            "title": "AgentName",
                                            "endpoint": "D38.1",
                                            "parameters": [
                                                { "key": "FromMonth", "value": "2024" },
                                                { "key": "FromYear", "value": "1" },
                                                { "key": "ToMonth", "value": "2024" },
                                                { "key": "ToYear", "value": "1" },
                                                { "key": "DistrictManagerCode", "value": "" },
                                                { "key": "DistrictManagerCodeDistrictManagerName", "value": "" },
                                                { "key": "ConfigTypeCode", "value": "" }
                                            ]
                                        },
                                        "context": {
                                            "point": {
                                                "onClick": {
                                                    "selectedValueColumn": "DistrictManagerCodeAgentCode",
                                                    "selectedTitle": "Product Group",
                                                    "visual": [
                                                        {
                                                            "columns": 12,
                                                            "rows": 2,
                                                            "visual": {
                                                                "id": 1,
                                                                "type": "advancedTable",
                                                                "colorTheme": 'colorTheme1',
                                                                "title": "Product Group",
                                                                "binding": {
                                                                    "data": {
                                                                        "columns": [
                                                                            {
                                                                                "name": 'Item Group',
                                                                                "columnName": 'ItemDivisionCode',
                                                                                "width": '200px',
                                                                                "align": "left",
                                                                                "sortable": true
                                                                            },
                                                                            {
                                                                                "name": 'Actual Sales',
                                                                                "columnName": 'ActualSales',
                                                                                "width": '140px',
                                                                                "align": "right",
                                                                                "sortable": true,
                                                                                "sum": true,
                                                                            },
                                                                            {
                                                                                "name": 'LY Sales',
                                                                                "columnName": 'LYSales',
                                                                                "width": '125px',
                                                                                "align": "right",
                                                                                "sortable": true,
                                                                                "sum": true,
                                                                            },
                                                                            {
                                                                                "name": 'Growth %',
                                                                                "columnName": 'Growth',
                                                                                "width": '125px',
                                                                                "align": "right",
                                                                                "sortable": true,
                                                                                "sum": false,
                                                                                "percent": true
                                                                            },
                                                                            {
                                                                                "name": 'Target',
                                                                                "columnName": 'TargetSales',
                                                                                "width": '125px',
                                                                                "align": "right",
                                                                                "sortable": true,
                                                                                "sum": true,
                                                                            },
                                                                            {
                                                                                "name": 'Performance %',
                                                                                "columnName": 'Performance',
                                                                                "width": '150px',
                                                                                "align": "right",
                                                                                "sortable": true,
                                                                                "sum": false,
                                                                                "percent": true
                                                                            }
                                                                        ],
                                                                        "title": "ItemDivisionCode",
                                                                        "endpoint": "D38.2",
                                                                        "parameters": [
                                                                            { "key": "FromMonth", "value": "2024" },
                                                                            { "key": "FromYear", "value": "1" },
                                                                            { "key": "ToMonth", "value": "2024" },
                                                                            { "key": "ToYear", "value": "1" },
                                                                            { "key": "DistrictManagerCode", "value": "" },
                                                                            { "key": "DistrictManagerCodeAgentCode", "value": "" },
                                                                            { "key": "ConfigTypeCode", "value": "" }
                                                                        ]
                                                                    },
                                                                    "context": {
                                                                        "point": {
                                                                            "onClick": {
                                                                                "selectedValueColumn": "DistrictCodeAgentCodeItemDivisionCode",
                                                                                "selectedTitle": "Product",
                                                                                "visual": [
                                                                                    {
                                                                                        "columns": 12,
                                                                                        "rows": 2,
                                                                                        "visual": {
                                                                                            "id": 1,
                                                                                            "type": "advancedTable",
                                                                                            "colorTheme": 'colorTheme1',
                                                                                            "title": "Product",
                                                                                            "binding": {
                                                                                                "data": {
                                                                                                    "columns": [
                                                                                                        {
                                                                                                            "name": 'Item Name',
                                                                                                            "columnName": 'ItemName',
                                                                                                            "width": '200px',
                                                                                                            "align": "left",
                                                                                                            "sortable": true
                                                                                                        },
                                                                                                        {
                                                                                                            "name": 'Actual Sales',
                                                                                                            "columnName": 'ActualSales',
                                                                                                            "width": '140px',
                                                                                                            "align": "right",
                                                                                                            "sortable": true,
                                                                                                            "sum": true,
                                                                                                        },
                                                                                                        {
                                                                                                            "name": 'LY Sales',
                                                                                                            "columnName": 'LYSales',
                                                                                                            "width": '125px',
                                                                                                            "align": "right",
                                                                                                            "sortable": true,
                                                                                                            "sum": true,
                                                                                                        },
                                                                                                        {
                                                                                                            "name": 'Growth %',
                                                                                                            "columnName": 'Growth',
                                                                                                            "width": '125px',
                                                                                                            "align": "right",
                                                                                                            "sortable": true,
                                                                                                            "sum": false,
                                                                                                            "percent": true
                                                                                                        },
                                                                                                        {
                                                                                                            "name": 'Target',
                                                                                                            "columnName": 'TargetSales',
                                                                                                            "width": '125px',
                                                                                                            "align": "right",
                                                                                                            "sortable": true,
                                                                                                            "sum": true,
                                                                                                        },
                                                                                                        {
                                                                                                            "name": 'Performance %',
                                                                                                            "columnName": 'Performance',
                                                                                                            "width": '150px',
                                                                                                            "align": "right",
                                                                                                            "sortable": true,
                                                                                                            "sum": false,
                                                                                                            "percent": true
                                                                                                        }
                                                                                                    ],
                                                                                                    "title": "ItemName",
                                                                                                    "endpoint": "D38.3",
                                                                                                    "parameters": [
                                                                                                        { "key": "FromMonth", "value": "2024" },
                                                                                                        { "key": "FromYear", "value": "1" },
                                                                                                        { "key": "ToMonth", "value": "2024" },
                                                                                                        { "key": "ToYear", "value": "1" },
                                                                                                        { "key": "DistrictManagerCode", "value": "" },
                                                                                                        { "key": "DistrictCodeAgentCodeItemDivisionCode", "value": "" },
                                                                                                        { "key": "ConfigTypeCode", "value": "" }
                                                                                                    ]
                                                                                                },
                                                                                                "context": {
                                                                                                    "point": {
                                                                                                        "onClick": {

                                                                                                        }
                                                                                                    }
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                ]
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        ]
                    }
                }
            }
        }
    }
}